module.exports = __webpack_public_path__ + "static/media/background.526ce633.png";